import { Box, Paragraph } from 'grommet'
import styled, { css } from 'styled-components'

export const Wrapper = styled(Box)`
  ${({ theme }) => css`
    background-color: ${theme.newColors.lightGray};
    margin-top: ${theme.newSpaces.lg}px;
    padding: ${theme.newSpaces.xs}px;
    padding-right: 11px;

    ${theme.below.mobileXL`
      padding: ${theme.newSpaces.xs2}px;
      margin-top: ${theme.newSpaces.xs}px;
      padding-right: 5px;
    `}
  `}
`

export const Content = styled.div`
  align-items: flex-start;
  display: flex;

  ${({ theme }) => css`
    ${theme.above.laptopL`
      justify-content: space-evenly;
    `}

    ${theme.below.laptopL`
      justify-content: space-between;
    `}
  `}
`

export const Title = styled(Paragraph)`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title2')}

    color: ${theme.newColors.primary};
    margin-top: ${theme.newSpaces.xs3}px;

    ${theme.above.laptopL`
      max-width: 40%;
    `}

    ${theme.below.laptopL`
      max-width: 225px;
    `}

    ${theme.below.mobileXL`
      font-size: 13px;
      line-height: ${theme.typography.mobile.button.medium.lineHeight}px;
      max-width: 124px;
    `}

    ${theme.below.mobileM`
      max-width: 90px;
    `}

    ${theme.below.mobileS`
      max-width: 80px;
    `}
  `}
`

export const Items = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 363px;

  ${({ theme }) => css`
    ${theme.below.mobileXL`
      margin-left: auto;
      width: 200px;
    `}
  `}
`

export const Item = styled.div`
  padding: 10px;

  ${({ theme }) => css`
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(3) {
      padding-top: 0;

      & > p:last-of-type {
        max-width: 152px;

        ${theme.below.mobileXL`
          max-width: 83px;
        `}
      }
    }

    &:nth-child(even) {
      padding-right: 0;
      padding-left: 18px;

      ${theme.below.mobileXL`
        padding-left: 10px;
      `}

      ${theme.below.mobileM`
        padding-left: 6px;
      `}
    }

    &:nth-child(odd) {
      ${theme.below.mobileXL`
        padding-left: 5px;
        padding-right: 5px;
      `}

      ${theme.below.mobileM`
        padding-right: 0;
      `}
    }

    &:first-child {
      padding-bottom: 12px;
      border-bottom: 1px solid ${theme.newColors.grayLine};

      ${theme.below.mobileXL`
        padding-bottom: 7px;
      `}
    }

    &:nth-child(2) {
      border-bottom: 1px solid ${theme.newColors.grayLine};
      border-left: 1px solid ${theme.newColors.grayLine};
      padding-bottom: 38px;

      ${theme.below.mobileXL`
        padding-bottom: 20px;
      `}
    }

    &:nth-child(3) {
      border-right: 1px solid ${theme.newColors.grayLine};
    }

    &:last-child {
      & > p:first-of-type {
        ${theme.getTypography('desktop', 'title', 'title2')}

        margin-bottom: ${theme.newSpaces.xs2}px;

        ${theme.below.mobileXL`
          font-size: 13px;
          line-height: ${theme.typography.mobile.button.medium.lineHeight}px;
        `}
      }

      & > p:last-of-type {
        max-width: 172px;

        ${theme.below.mobileXL`
          max-width: 92px;
        `}
      }

      ${theme.below.mobileXL`
        padding-top: 5px;
      `}
  `}
`

export const ItemTitle = styled(Paragraph)`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title1')}

    color: ${theme.newColors.accent};

    ${theme.below.mobileXL`
      font-size: 19px;
      line-height: ${theme.typography.desktop.title.title4.lineHeight}px;
    `}
  `}
`

export const ItemText = styled(Paragraph)`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'body', 'body3')}

    color: ${theme.newColors.darkGray};

    ${theme.below.mobileXL`
      font-size: 8px;
      line-height: 13px;
    `}
  `}
`
